import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { createSelfProgram } from '../lib/database';
import { useSwipeBack } from '../hooks/useSwipeBack';
import './CreateProgram.css';

function CreateProgram() {
  const navigate = useNavigate();
  const { profile } = useAuth();
  const [programName, setProgramName] = useState('');
  const [description, setDescription] = useState('');
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!programName.trim()) {
      setError('Il nome del programma è obbligatorio');
      return;
    }

    try {
      setCreating(true);
      setError('');

      const newProgram = await createSelfProgram(profile.id, {
        name: programName.trim(),
        description: description.trim() || null
      });

      // Navigate to edit the new program
      navigate(`/athlete/programs/${newProgram.id}/edit`, {
        state: { isNewProgram: true }
      });
    } catch (err) {
      console.error('Error creating program:', err);
      setError('Errore nella creazione del programma. Riprova.');
    } finally {
      setCreating(false);
    }
  };

  const handleBack = () => {
    navigate('/athlete/programs');
  };

  const { handleTouchStart, handleTouchEnd } = useSwipeBack(handleBack);

  return (
    <div
      className="cp-container"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {/* Sticky Header */}
      <header className="cp-header">
        <button className="cp-header-back" onClick={handleBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <span className="cp-header-title">Nuova Scheda</span>
      </header>

      {/* Main */}
      <main className="cp-main">
        <p className="cp-hint">
          Crea una scheda personalizzata, poi potrai aggiungere workout ed esercizi.
        </p>

        <form onSubmit={handleSubmit} className="cp-form">
          <div className="cp-field">
            <label htmlFor="cpName">Nome *</label>
            <input
              id="cpName"
              type="text"
              value={programName}
              onChange={(e) => setProgramName(e.target.value)}
              placeholder="Es. PPL 6 giorni, Upper/Lower..."
              maxLength={100}
              autoFocus
            />
          </div>

          <div className="cp-field">
            <label htmlFor="cpDesc">Descrizione <span className="cp-optional">opzionale</span></label>
            <textarea
              id="cpDesc"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Obiettivo o caratteristiche..."
              rows={3}
              maxLength={500}
            />
          </div>

          {error && (
            <div className="cp-error">{error}</div>
          )}

          <div className="cp-actions">
            <button
              type="button"
              className="cp-btn-cancel"
              onClick={handleBack}
              disabled={creating}
            >
              Annulla
            </button>
            <button
              type="submit"
              className="cp-btn-create"
              disabled={creating || !programName.trim()}
            >
              {creating ? 'Creazione...' : 'Crea Scheda'}
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}

export default CreateProgram;
